import { gql } from '@apollo/client';

export const GET_SUB_ACCOUNT_ENTITIES = gql`
  query GetSubAccountEntities($subTenantId: String) {
    vm {
      enterpriseSubAccountEntities(subTenantId: $subTenantId) {
        entityType
        masterEntityId
        name
        isMapped
        subEntityId
        relatedEntityIds
      }
    }
  }
`;
